import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl';

const InputMUI = ({ label, value, varient, name, id, onChange, size, type, readOnly, required, inputProps }) => {

    const [inputValue, setInputValue] = useState("")
    const inputChange = (e) => {
        setInputValue(e.target.value)
        onChange(e.target.value)
    }

    useEffect(() => {
        setInputValue(value)
    })

    return (
        <FormControl fullWidth>
            <TextField
                label={label !== undefined ? label : ''}
                type={type !== undefined ? type : 'text'}
                variant={varient !== undefined ? varient : 'standard'}
                value={inputValue !== null ? inputValue : ''}
                name={name !== undefined ? name : ''}
                id={id !== undefined ? id : ''}
                onChange={e => inputChange(e)}
                size={size !== undefined ? size : ''}
                required={required !== undefined ? required : false}
                sx={{
                    paddingBottom: "12px",
                    '& .MuiInputBase-input': {
                        fontSize: '16px',
                        paddingBottom: '8px',
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: '14px', 
                    }
                }}
                inputProps={{
                    readOnly: readOnly !== undefined ? readOnly : false,
                    ...inputProps
                }}
            />
        </FormControl>
    )
}

export default InputMUI;
